import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface IMenuComponentConfiguration extends CM.Component.IConfiguration {
};

/**
 * Control element, it lists options or commands for the user to select in order to execute the proper application function
 **/
export class MenuComponent<
	TNode extends HTMLElement,
	TComponent extends MenuComponent<TNode, TComponent, TConfiguration>,
	TConfiguration extends IMenuComponentConfiguration
> extends CM.DOMComponent<TNode, TComponent, TConfiguration> {
	component_DOM : TNode;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <TNode> STD.DOM.factory({}); // /!\ type is HTMLDivElement, not TNode
	};
};
export namespace NS {
	export type Configuration = IMenuComponentConfiguration;
	export const Component = MenuComponent;
	export type Component<
		X extends HTMLElement,
		Y extends MenuComponent<X, Y, Z>,
		Z extends IMenuComponentConfiguration
	> = MenuComponent<X, Y, Z>;
}
;
CM.declare({
	id :   'menu',
	type : MenuComponent
});
